import { Avatar, Skeleton, Text, UnstyledButton } from "@mantine/core";
import { IconSelector } from "@tabler/icons-react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { useGetEvents } from "../../api/event";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import classes from "./EventSwitcher.module.css";

export function EventSwitcher({ collapsed }) {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const currentWorkspace = getCurrentWorkspace(user);
  const activeEventId = user?.config?.adminUI?.workspaces.find(
    (ws) => ws.id === currentWorkspace?.id
  )?.eventId;

  const { data: eventsData, isPending: isPendingEvents } = useGetEvents({
    workspace: currentWorkspace?.id,
  });

  const currentEvent = eventsData?.data?.find(
    (event) => event.id === activeEventId
  );
  const hasEvents = (eventsData?.data?.length || 0) > 0;

  const label = currentEvent?.name
    ? currentEvent.name
    : hasEvents
      ? "Select Event"
      : "No events found";

  if (currentWorkspace && isPendingEvents && !collapsed) {
    return (
      <div className={classes.switcher}>
        <Skeleton circle size={30} />
        <div className={classes.info}>
          <Skeleton height={8} width="40%" mb={4} />
          <Skeleton height={12} width="70%" />
        </div>
      </div>
    );
  }

  return (
    <UnstyledButton
      className={`${classes.switcher} ${collapsed ? classes.collapsed : ""}`}
      onClick={() => navigate("/app")}
    >
      <Avatar
        src={currentEvent?.config?.logoImage}
        radius="md"
        size={collapsed ? 35 : 32}
        color="blue"
      >
        {currentEvent?.name?.[0] || currentWorkspace?.name?.[0]}
      </Avatar>
      {!collapsed && (
        <>
          <div className={classes.info}>
            <Text className={classes.eventName}>{label}</Text>
          </div>
          <IconSelector size={16} className={classes.chevron} />
        </>
      )}
    </UnstyledButton>
  );
}
